export default __webpack_public_path__ + "static/media/0048.f90ef451.png";